import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b09b0de0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title-info" }

import { orderApi } from "@/service/api"
import { sjyAlert } from "@/utils/alert"
import { useRoute, useRouter } from "vue-router"

import { getCurrentInstance, ref } from "vue"
interface Props {
  id: number
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PostCancel',
  props: {
    id: { default: 0 }
  },
  setup(__props: any) {

const { id } = __props as { id: number };

const { proxy } = getCurrentInstance() as any



let router = useRouter()
let cancelSale = () => {
  proxy.$ConfirmDialog.show({
    tips: "您将撤销本次退款申请，确定继续吗？",
    onConfirm: () => {
      orderApi.cancelSale(id).then(() => {
        sjyAlert("已取消", "success")
        setTimeout(() => {
          //router.go(0)
        }, 1000)
      })
    },
    onCancel: () => {},
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", _hoisted_1, [
    _createElementVNode("span", null, [
      _createTextVNode("您还可以："),
      _createElementVNode("span", {
        class: "info-a",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(cancelSale)()))
      }, "撤销申请")
    ])
  ]))
}
}

})